import angular from 'angular';
/**
 * @ngdoc module
 * @name flowingly.runner.flows.search
 * @module flowingly.runner.flows.search
 * @description This module configures the page used to display the flow search results.
 */
const m = angular.module('flowingly.runner.flows.search', []);
